<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">审查调查></span>
        <span @click="GoreportEvaluation">党纪政务处分></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>陕西省政府原党组成员、副省长陈国强严重违纪违法被开除党籍和公职</h1>
         <div class="first">
        <span class="third">来源：新华社</span>
         <span class="si">|</span>
        <span>发布时间：2020-5-20 13:30</span>
      </div>
     <div class="xh"></div>
        <h3 class="yi">日前，经中共中央批准，中央纪委国家监委对陕西省政府原党组成员、副省长陈国强严重违纪违法问题进行了立案审查调查。</h3>
        <h3>　经查，陈国强丧失理想信念，背弃初心使命，对党不忠诚不老实，为谋求个人职务晋升大搞政治攀附和人身依附，对抗组织审查；违反中央八项规定精神，多次接受可能影响公正执行公务的宴请和旅游安排；违规干预插手干部人事工作，不按规定报告个人有关事项；贪欲膨胀，收受礼品、礼金，甘于被“围猎”，将公权力作为谋取私利的工具，在企业经营、干部职务调整等方面利用职务上的便利为他人谋利，并非法收受巨额财物。.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>陈国强严重违反党的政治纪律、组织纪律、廉洁纪律，构成严重职务违法并涉嫌受贿犯罪，且在党的十八大后不收敛、不收手，性质严重，影响恶劣，应予严肃处理。依据《中国共产党纪律处分条例》《中华人民共和国监察法》等有关规定，经中央纪委常委会会议研究并报中共中央批准，决定给予陈国强开除党籍处分；由国家监委给予其开除公职处分；终止其陕西省第十三次党代会代表资格；收缴其违纪违法所得；将其涉嫌犯罪问题移送检察机关依法审查起诉，所涉财物随案移送。-2018年在担任该所党支部书记、所长期间，违反中央八项规定精神、违反政治纪律、挪用公款、非法占有公共财物等，被群众多次举报。其中违反中央八项规定精神达3次之多，从党内警告处分直至给予留党察看。分析多次被举报受处分人员情况，国家工作人员71人，农村党员干部108人。其中村（社区）主职干部被举报频率较高，受处分达72人，占比40.22%。</h3>
        <h3>
          <b>　陈国强简历</b>
        </h3>
        <h3>　陈国强，男，汉族，1962年5月生，安徽宿州人，1984年7月参加工作，1986年6月加入中国共产党，中央党校研究生，高级管理人员工商管理硕士。</h3>
        <h3>　1981.09—1984.07 西安基础大学机械系机械制造专业学习</h3>
        <h3>　1984.07—1994.10 陕西省劳动人事厅、劳动厅安全监察处、计划统计处科员、副主任科员（其间：1986.10—1987.10陕西省淳化县润镇乡蹲点扶贫）</h3>
        <h3>　1994.10—2000.09 陕西省劳动厅综合计划与工资处副处长（其间：1996.08—1998.12中央党校领导干部函授学院本科班经济管理专业学习）</h3>
        <h3>2000.09—2004.06 陕西省劳动和社会保障厅医疗保险处处长（其间：2002.10—2003.01广东省深圳市社会保险管理局挂职；2003.03—2003.07陕西省委党校中青年干部培训班学习）</h3>

        <h3>　2004.06—2009.01 陕西省劳动和社会保障厅副厅长、党组成员</h3>
        <h3>　（2003.09—2006.07中央党校研究生院在职研究生经济管理专业学习；2007.08—2008.02美国西弗吉尼亚大学学习）</h3>
        <h3>　2009.01—2010.11 陕西省人力资源和社会保障厅副厅长、党组成员</h3>
        <h3>（2008.09—2010.09长江商学院高级管理人员工商管理硕士专业学习，获高级管理人员工商管理硕士学位）</h3>
        <h3>　2010.11—2013.02 陕西省政府副秘书长、办公厅党组成员</h3>
        <h3>2013.02—2018.01 陕西省政府秘书长、党组成员、办公厅党组书记兼省行政学院（陕西经济管理职业技术学院）院长（其间：2015.09—2016.01中央党校中青年干部培训一班学习）</h3>
        <h3>　2018.01 陕西省政府副省长、党组成员，省政府秘书长（兼）办公厅党组书记兼省行政学院（陕西经济管理职业技术学院）院长</h3>
        <h3>2019.03 陕西省十三届人大常委会第十次会议第二次全体会议表决通过：免去陈国强的陕西省人民政府副省长职务</h3>
        <h3>　第十三届省委委员，省第十三次党代会代表。省十三届人大代表。</h3>
        <h3>（人民网资料 截至2019年3月）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/Investigate");
    },
    GoreportEvaluation() {
      this.$router.push("/Investigate/DangJi" );
    },
   
  }
};
</script>

<style lang="less" scoped>
.si{
   margin: 0 16px;
 }
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}

.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.yi {
  margin-top: 20px;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
</style>